import { HIDDEN_AUDIO_MODE_KEYS, HIDDEN_VIDEO_FX_NAMES } from "../constants";
import { buildAudioModes } from "./audio-modes";
import ModeTile from "./mode-tile";

const AMBIANCE_MODE_KEYS = new Set([
  "rainy",
  "coffeeShop",
  "seashore",
  "berghain",
  "hotelLounge",
  "cocktailBar",
]);

function renderAudioModeTiles({
  modes,
  isProFeaturesLocked,
  holdingTileKey,
  draggingTileKey,
  revealingTileKey,
  releasingTileKey,
  fillGrowingKeys,
  onUpgradeClick,
  tileHandlers,
}) {
  return modes.map((mode) => (
    <ModeTile
      key={mode.key}
      mode={mode}
      isProFeaturesLocked={isProFeaturesLocked}
      holdingTileKey={holdingTileKey}
      draggingTileKey={draggingTileKey}
      revealingTileKey={revealingTileKey}
      releasingTileKey={releasingTileKey}
      fillGrowingKeys={fillGrowingKeys}
      onUpgradeClick={onUpgradeClick}
      {...tileHandlers}
    />
  ));
}

export default function EffectsSection({
  props,
  tileState,
  tileHandlers,
}) {
  const { videoFxs, videoFx, isProFeaturesLocked, onUpgradeClick, onVideoFxChange } =
    props;
  const {
    holdingTileKey,
    draggingTileKey,
    revealingTileKey,
    releasingTileKey,
    fillGrowingKeys,
  } = tileState;

  const visibleFxs = videoFxs.filter(
    ({ name }) => !HIDDEN_VIDEO_FX_NAMES.includes(name),
  );
  const allAudioModes = buildAudioModes(props).filter(
    (mode) => !HIDDEN_AUDIO_MODE_KEYS.includes(mode.key),
  );
  const audioModes = allAudioModes.filter(
    (mode) => !AMBIANCE_MODE_KEYS.has(mode.key),
  );
  const ambianceModes = allAudioModes.filter((mode) =>
    AMBIANCE_MODE_KEYS.has(mode.key),
  );

  const tileProps = {
    isProFeaturesLocked,
    holdingTileKey,
    draggingTileKey,
    revealingTileKey,
    releasingTileKey,
    fillGrowingKeys,
    onUpgradeClick,
    tileHandlers,
  };

  return (
    <>
      <div className="content__item content__item--audio">
        <div className="content__title">Audio Effects</div>
        <div className="modes-grid modes-grid--audio">
          {renderAudioModeTiles({ modes: audioModes, ...tileProps })}
        </div>
      </div>
      <div className="content__item content__item--video">
        <div className="content__title">Video Effects</div>
        <div className="modes-grid modes-grid--video">
          {visibleFxs.map(({ value, name }) => {
            const isLocked = isProFeaturesLocked;
            const isActive = videoFx === value;
            return (
              <button
                key={value}
                type="button"
                className={`mode-tile ${!isLocked ? "mode-tile--toggle" : ""} ${isActive ? "mode-tile--active" : ""} ${isLocked ? "mode-tile--locked" : ""}`}
                onClick={() => {
                  if (isLocked) {
                    onUpgradeClick();
                    return;
                  }
                  onVideoFxChange(isActive ? null : value);
                }}
              >
                <span className="mode-tile__label">
                  <span className="mode-tile__label-text">{name}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
      <div className="content__item content__item--ambiance">
        <div className="content__title">Ambient Effects</div>
        <div className="modes-grid modes-grid--ambiance">
          {renderAudioModeTiles({ modes: ambianceModes, ...tileProps })}
        </div>
      </div>
    </>
  );
}
